export default __webpack_public_path__ + "93e6bd6.png";